import { ComboBox as CarbonComboBox, InlineLoading } from "carbon-components-react";
import { useEffect, useState } from "react";

const ComboBox = (props) => {

  const [items, setItems] = useState([])
  const [key, setKey] = useState(0)
  const [defaultValue, setDefaultValue] = useState(null)

  useEffect(() => {
    let defaultValue_ = props.defaultValue

    if (props.items && props.items[0]) {
      props.items.filter(item => (item !== undefined && item !== null)).forEach((lang) => {
        if (lang.id === "" + defaultValue_) {
          defaultValue_ = lang;
        }
      });
      // if (!init && defaultValue_) {
      //   setDefaultValue(defaultValue_)
      //   setInit(true)
      // }
      // else if (!defaultValue_) {
      //   setDefaultValue(null)
      // }
      setDefaultValue(defaultValue_)
      // if (defaultValue_) {
      //   setInit(true)
      // }
    }

    const newKey = key + 1
    setKey(newKey)
    setItems(props.items)
  }, [props.defaultValue, props.items])


  return (props.loading) ? (
    <InlineLoading description={props.label} />
  ) : (
    <CarbonComboBox
      ariaLabel="ComboBox"
      id={props.id}
      items={items}
      label={props.label}
      titleText={props.label}
      helperText={props.helperText}
      invalid={props.invalid}
      onChange={(e) => props.onChange(e)}
      invalidText={props.helperText}
      placeholder={props.placeholder || props.label}
      initialSelectedItem={defaultValue}
      // selectedItem={value}
      disabled={props.disabled}
      key={`combobox-${props.id}-${key}`}
    />
  );
};

export default ComboBox